import PropTypes from 'prop-types';

import { Bar } from 'react-chartjs-2';
import { useRef } from 'react';
import './plugins';
import { CHART_COLORS } from '@/consts';
import { horizontalLegendBar } from './plugins';

const buildOptions = yAxisLabel => ({
  plugins: {
    title: {
      display: false,
    },
    legend: {
      display: false,
    },
    yAxisLabel: {
      enabled: true,
      text: yAxisLabel,
    },
    tooltip: {
      callbacks: {
        label: context => {
          const { percentage } = context.dataset;
          return percentage === null ? '—' : `${percentage.toFixed(2)}%`;
        },

        title: context => {
          return context[0].dataset.label;
        },
      },
    },
  },
  indexAxis: 'y',
  responsive: true,
  maintainAspectRatio: false,
  animation: true,
  layout: {
    padding: {
      top: 50,
      bottom: 140,
      left: 20,
    },
  },
  borderSkipped: false,
  borderWidth: 1,
  scales: {
    x: {
      max: 100,
      display: false,
      stacked: true,
      grid: {
        display: false,
        drawBorder: false,
        drawTicks: false,
      },
      ticks: {
        display: false,
      },
    },
    y: {
      display: false,
      stacked: true,
      beginAtZero: true,
      grid: {
        display: false,
        drawBorder: false,
        drawTicks: false,
      },
      ticks: {
        display: false,
      },
    },
  },
});

const buildData = (data, colors) => {
  // rows size the segments; percentages (defaulting to rows) are what the labels show
  const { rows, labels, percentages = rows } = data;
  const datasets = rows.map((row, i) => ({
    label: labels[i],
    data: [row],
    percentage: percentages[i],
    backgroundColor: colors[i],
    borderColor: '#000000',
    borderWidth: 0.5,
    maxBarThickness: 41,
    barThickness: 41,
    borderSkipped: false,
  }));

  return {
    labels: [''],
    datasets,
  };
};

const HorizontalStackedBarChart = ({ rows, labels, percentages, yAxisLabel, colors = CHART_COLORS }) => {
  const options = buildOptions(yAxisLabel);
  const data = buildData({ rows, labels, percentages }, colors);
  const ref = useRef();

  return (
    <div className="relative h-60">
      <Bar ref={ref} options={options} data={data} plugins={[horizontalLegendBar]} />
    </div>
  );
};

HorizontalStackedBarChart.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.number),
  labels: PropTypes.arrayOf(PropTypes.string),
  percentages: PropTypes.arrayOf(PropTypes.number),
  colors: PropTypes.arrayOf(PropTypes.string),
  yAxisLabel: PropTypes.string,
};

export default HorizontalStackedBarChart;
